import React from 'react';
import { Link } from 'react-router-dom';
import seoData from '../data/seo.json';

const Footer = () => {
    const phone = seoData.business.phone;
    const email = seoData.business.email;
    const phoneClean = phone.replace(/[^0-9]/g, '');
    const social = seoData.business.socialMedia;

    return (
        <footer className="glass-panel mt-20 mx-4 mb-4 p-8 text-center text-text-light animate-fade-in-up opacity-0 animation-delay-500">
            <div className="container mx-auto">
                <div className="grid md:grid-cols-3 gap-8 mb-8 text-left">
                    <div>
                        <h3 className="text-xl font-bold text-text-dark mb-4">{seoData.business.name}</h3>
                        <p className="mb-4">{seoData.business.description}</p>
                        {/* Social Links */}
                        <div className="flex gap-4 mt-4">
                            {social.facebook && (
                                <a 
                                    href={social.facebook} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-text-light hover:text-primary-blue transition-colors"
                                    aria-label="Facebook"
                                >
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                    </svg>
                                </a>
                            )}
                            {social.instagram && (
                                <a 
                                    href={social.instagram} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-text-light hover:text-primary-blue transition-colors"
                                    aria-label="Instagram"
                                >
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                                    </svg>
                                </a>
                            )}
                            {social.googleBusiness && (
                                <a 
                                    href={social.googleBusiness} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-text-light hover:text-primary-blue transition-colors"
                                    aria-label="Google Reviews"
                                >
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                                    </svg>
                                </a>
                            )}
                        </div>
                    </div>
                    <div>
                        <h4 className="font-bold text-text-dark mb-4">Services</h4>
                        <ul className="space-y-2">
                            <li><Link to="/services" className="hover:text-primary-blue transition-colors">Emergency Plumber Calgary</Link></li>
                            <li><Link to="/services" className="hover:text-primary-blue transition-colors">Furnace Repair Calgary</Link></li>
                            <li><Link to="/services" className="hover:text-primary-blue transition-colors">Drain Cleaning Calgary</Link></li>
                            <li><Link to="/services" className="hover:text-primary-blue transition-colors">Water Heater Repair Calgary</Link></li>
                        </ul>
                    </div>
                    <div className="md:text-right">
                        <h4 className="font-bold text-text-dark mb-4">24/7 Emergency Contact</h4>
                        <p>
                            Phone: <a href={`tel:${phoneClean}`} className="hover:text-primary-blue transition-colors font-semibold">{phone}</a>
                        </p>
                        <p>
                            Email: <a href={`mailto:${email}`} className="hover:text-primary-blue transition-colors">{email}</a>
                        </p>
                        <p className="mt-2 text-sm">{seoData.business.address.streetAddress}</p>
                        <p className="text-sm">{seoData.business.address.addressLocality}, {seoData.business.address.addressRegion} {seoData.business.address.postalCode}</p>
                        <p className="mt-4 text-primary-blue font-semibold">Serving Calgary & Area</p>
                    </div>
                </div>
                <div className="border-t border-glass-border pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p>&copy; {new Date().getFullYear()} {seoData.business.name}. All rights reserved.</p>
                        <nav className="flex gap-6">
                            <Link to="/" className="hover:text-primary-blue transition-colors">Home</Link>
                            <Link to="/services" className="hover:text-primary-blue transition-colors">Services</Link>
                            <Link to="/about" className="hover:text-primary-blue transition-colors">About</Link>
                            <Link to="/contact" className="hover:text-primary-blue transition-colors">Contact</Link>
                        </nav>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
